import React, {useState} from "react";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import {Button} from "react-bulma-components";
import {fixed} from "lodash/fp/_falseOptions";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import {readableDate} from "../../utils";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";


export default function FixedExpenseRow({fixedExpense, onChange, onSave, onDelete, index, departments, departmentObjects}){
    const [editable, setEditable] = useState(false);

    const onDepartmentChange = (e) => {
        const toUpdate = {
            target: {
                name: "department",
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }
    return (
        <tr>
            <td>
                <DepartmentSelector
                    options={departments}
                    value={fixedExpense.department}
                    name={"department"}
                    blank={false}
                    editable={editable}
                    setEditable={setEditable}
                    onSave={() => {
                        setEditable(false);
                        onSave(fixedExpense);
                    }}
                    onChange={onDepartmentChange}
                    disabled={!editable}
                    inlineEdit={true}
                />
            </td>
            <td>{(fixedExpense.supplier && fixedExpense.supplier.id) ? fixedExpense.supplier.display_name : ""}</td>
            {useEditableTableTextAreaCell({
                propName: "description",
                value: fixedExpense.description,
                onChange: (e) => onChange(e, index),
                onSave: () => {
                        setEditable(false);
                        onSave(fixedExpense);
                    },
                editable,
                setEditable,
                inlineEdit: true
            })}
            <td>{readableDate(fixedExpense.start_date)}</td>
            {useEditableTableDateCell({
                propName: "renewal_date",
                value: fixedExpense.renewal_date,
                onChange: (e) => onChange(e, index),
                onSave: () => {
                        setEditable(false);
                        onSave(fixedExpense);
                    },
                editable,
                setEditable,
                inlineEdit: true
            })}
            {useEditableTableCostCell({
                propName: "yearly_amount",
                value: fixedExpense.yearly_amount,
                onChange: (e) => onChange(e, index),
                onSave: () => {
                        setEditable(false);
                        onSave(fixedExpense);
                    },
                editable,
                setEditable,
                inlineEdit: true
            })}
            <td>
                <Button
                    color={"danger"}
                    onClick={() => onDelete(fixedExpense)}
                >
                    X
                </Button>
            </td>
        </tr>
    )





}